import {
    SAVE_B2B_PLATFORM,
    GET_EONE_ST_LIST,
    GET_PLATFM_CODE_LIST,
    GET_ST_INFOR,
    GET_B2B_PLATFORM_LIST,
    B2B_SEARCH_FIELD,
    B2B_FORM_EDIT_DATA,
    B2B_FORM_UPDATE
} from "Actions/b2bManagement";
import update from 'immutability-helper';

const initialState = {
};

export function b2bManagement(state = initialState, action) {
    let payload = {}   
    switch (action.type) {
        case SAVE_B2B_PLATFORM:
        case GET_PLATFM_CODE_LIST:
        case B2B_FORM_UPDATE:
            payload.platformList = action.payload;
            return { ...state, ...payload }
        case B2B_FORM_EDIT_DATA:
            payload.platformEditList = action.payload;
            return { ...state, ...payload }
        case GET_EONE_ST_LIST:
        case GET_ST_INFOR:
            return {
                ...state,
                ...payload
            }

        case B2B_SEARCH_FIELD:
                return update(state, { searchfields: action.payload });
        case GET_B2B_PLATFORM_LIST:
                if(action.payload.pageNum === 1) payload.b2bPlatformList = action.payload.data;
                if(action.payload.pageNum > 1) {
                    payload.b2bPlatformList = state.b2bPlatformList.concat(action.payload.data);
                }
                return { ...state, ...payload };
        default:
            return state;
    }
}
